import {
    React, ui, pr,
    observer,
    i18n, debug,
    RouteComponentProps
} from "aaa";

import { SigningComponent } from "../signing/views/SigningComponent";
import { ISigningInfo, ISigningResponse } from "types/signing";
import { IPostContactResponse } from "types/contact";
import { phoneNumberToString, ContactsStore } from "stores/ContactsStore";

type IProps = {
    contactsStore: ContactsStore;
    contactResponse: IPostContactResponse;
    onClose: () => void;
    onRetry: () => void;
    onSuccess: () => void;
};

@observer
export class NewPhoneSigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                signingInfo={this.props.contactResponse.signInfo}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelSet>
                                <pr.SigningLabelTitle>{ui.__("phone.signing.title")}</pr.SigningLabelTitle>
                                <pr.SigningLabel>{phoneNumberToString(this.props.contactResponse.contact)}</pr.SigningLabel>
                            </pr.SigningLabelSet>
                        </pr.SigningLabelContainer>
                    </div>
                }

                onSuccess={async (response: ISigningResponse) => {
                    debug.log("### Signing success", response);
                    this.props.onSuccess();
                }}
                onRetry={this.props.onRetry}
                onClose={this.props.onClose}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/NewPhoneSigning.tsx